import { render } from "./ProductActions.vue?vue&type=template&id=3ba749f0&scoped=true&ts=true"
import script from "./ProductActions.vue?vue&type=script&lang=ts"
export * from "./ProductActions.vue?vue&type=script&lang=ts"

import "./ProductActions.vue?vue&type=style&index=0&id=3ba749f0&lang=scss&scoped=true"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ba749f0"]])

export default __exports__